import { OpenEditWindowParams } from "@multiweb/types/react";

/**
    * Vrací parametry potřebné k otevření editačního okna.
    * Pokud nejsou definovány showAttrs a editWindow, vrací undefined.
    * @param dataSourceKey Unikátní klíč pro DataSource.
    * @param recordId Unikátní klíč pro záznam.
    * @param attributeId Unikátní klíč pro atribut.
    * @param showAttrs Atributy zobrazené v jedné buňce (například u LOVAttribute).
    * @param editWindow Název formuláře k otevření.
    */
export const createOpenEditWindowParams = (
    dataSourceKey: string,
    recordId: string,
    attributeId: string,
    showAttrs: string[] | null = null,
    editWindow: string | null = null,
): OpenEditWindowParams | undefined => {
    if (showAttrs && editWindow) {
        return {
            dataSourceKey,
            recordId,
            attributeId,
            editWindow,
        };
    }
    return undefined;
};
